export default __webpack_public_path__ + "static/media/camera.ff4c0e99.svg";